import React, {PureComponent} from 'react';
import {compose} from 'redux';
import {connect} from "react-redux";
import {
    Typography, withStyles, Button
} from "@material-ui/core";
import {Done as SuccessIcon} from '@material-ui/icons';
import classNames from 'classnames';

const styles = theme => ({
    root: {

    },
    icon: {
        fontSize: 72,
        color: '#FFFFFF',
        marginBottom: theme.spacing.unit*2,
    },
    button: {
        marginTop: theme.spacing.unit,

        '&.facebook': {
            backgroundColor: '#3b5998',
        },
        '&.youtube': {
            backgroundColor: '#ff0000',
        },
        '&.twitch': {
            backgroundColor: '#6441A4',
        }
    }
});

class RegisterSuccess extends PureComponent {

    render() {
        const {classes, fromUrl} = this.props;

        return (
            <div className={classes.root}>
                <SuccessIcon className={classes.icon} />
                <Typography variant="title" paragraph>
                    Du har nu internet!
                </Typography>
                <Typography variant="body2" paragraph>
                    Tack för att du använder Pantanova WiFi.
                </Typography>
                <Button className={classNames(classes.button, 'facebook')} color="primary" component="a" href="https://www.facebook.com/" target="_blank" rel="noopener" variant="raised" fullWidth>
                    Facebook
                </Button>
                <Button className={classNames(classes.button, 'youtube')} color="primary" component="a" href="https://youtube.com/" target="_blank" rel="noopener" variant="raised" fullWidth>
                    YouTube
                </Button>
                <Button className={classNames(classes.button, 'twitch')} color="primary" component="a" href="https://www.twitch.tv/" target="_blank" rel="noopener" variant="raised" fullWidth>
                    Twitch
                </Button>
                {typeof fromUrl !== 'string' || fromUrl.length <= 1 || fromUrl.indexOf('connectivitycheck') ? null : (
                    <Button className={classNames(classes.button, 'continue')} color="primary" component="a" href={fromUrl} target="_blank" rel="noopener" variant="raised" fullWidth>
                        Fortsätt till sidan jag kom ifrån
                    </Button>
                )}
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
    fromUrl: state.wifi.url,
});

export default compose(
    withStyles(styles, {withTheme: true}),
    connect(mapStateToProps),
)(RegisterSuccess);



// WEBPACK FOOTER //
// ./src/containers/Success.js